module.exports = __webpack_public_path__ + "img/location.b3a58901.svg";